var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6056 12.5402C29.9581 12.1879 30.1561 11.71 30.1562 11.2116C30.1562 10.7132 29.9583 10.2353 29.606 9.88281C29.2536 9.53037 28.7757 9.33234 28.2773 9.33228C27.779 9.33221 27.301 9.53013 26.9486 9.88248L18.0521 18.781C17.8973 18.9353 17.7828 19.1253 17.7188 19.3343L16.8382 22.2353C16.8209 22.293 16.8196 22.3542 16.8344 22.4125C16.8492 22.4709 16.8795 22.5241 16.922 22.5666C16.9646 22.6091 17.0179 22.6393 17.0763 22.654C17.1346 22.6687 17.1958 22.6673 17.2535 22.6499L20.1552 21.77C20.364 21.7065 20.5539 21.5928 20.7085 21.4387L29.6056 12.5402Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9985,
    height: 15.9985,
    fill: "white",
    transform: "translate(15.4912 7.99927)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6090a82a1f5a8348ddfc79118ab096c2.svg";
export { ForwardRef as ReactComponent };